<template>
  <XField
    :errors="validationErrors(formattedLabel)"
    :errorStyle="formFieldsCheckErrorStyle">
    <XCheckbox
      color="secondary"
      optionalClass="ml-2 text-xs font-lighter italic"
      :labelStyle="labelStyle"
      :data-vv-name="formattedLabel"
      :invalid="validationHasErrors(formattedLabel)"
      :optional="isOptional"
      v-model="fieldValue"
      v-validate="parameters.required ? 'required:true' : ''"
      @change="validate">
      <template slot="label">
        <a
          v-if="parameters.config.url"
          target="_blank"
          :href="parameters.config.url"
          :style="labelStyle">
          {{ parameters.config.label }}
        </a>
        <span
          v-else
          :style="labelStyle">{{ parameters.config.label }}</span>
      </template>
    </XCheckbox>
  </XField>
</template>

<script>
import _ from 'lodash'

import InputMixin from './InputMixin'

export default {
  mixins: [InputMixin],

  data () {
    return {
      fieldValue: this.value === 'true' || this.value === true
    }
  },

  computed: {
    formattedLabel () {
      return _.lowerCase(this.parameters.config.label)
    }
  },

  methods: {
    validate () {
      this.$validator.validate(this.formattedLabel)
    }
  }
}
</script>
